import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';

import { CommunicationRecordsPage } from './communication-records.page';

const routes: Routes = [
  {
    path: '',
    component: CommunicationRecordsPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild(routes)
  ],
  declarations: [CommunicationRecordsPage]
})
export class CommunicationRecordsPageModule {}
